import React, { createContext, useReducer } from 'react'

const initialState = {
  eventLists: [],
  // eventLists: [
  //   {
  //     id: "ONE",
  //     events: [
  //       {
  //         title: "test one",
  //         startTime: "2019-10-01T10:00:00",
  //         endTime: "2019-10-01T12:00:00",
  //         address: "123 Main St",
  //         eventLink: "/",
  //         categories: [
  //           {
  //             slug: "cat1"
  //           },
  //           {
  //             slug: "cat2"
  //           }
  //         ]
  //       },
  //       {
  //         title: "test two",
  //         startTime: "2019-10-02T00:00:00",
  //         endTime: "2019-10-03T00:00:00",
  //         address: "123 Main St",
  //         eventLink: "/",
  //         categories: [
  //           {
  //             slug: "cat1"
  //           },
  //           {
  //             slug: "cat3"
  //           }
  //         ]
  //       },
  //       {
  //         title: "test three",
  //         startTime: "2019-10-05T10:00:00",
  //         endTime: "2019-10-05T12:00:00",
  //         address: "123 Main St",
  //         eventLink: "/",
  //         categories: [
  //           {
  //             slug: "cat3"
  //           }
  //         ]
  //       },
  //       {
  //         title: "test four",
  //         startTime: "2019-10-10T10:00:00",
  //         endTime: "2019-11-10T10:00:00",
  //         address: "123 Main St",
  //         eventLink: "/",
  //         categories: []
  //       }
  //     ],
  //     categories: [
  //       {
  //         name: "cat 1",
  //         slug: "cat1"
  //       },
  //       {
  //         name: "cat 2",
  //         slug: "cat2"
  //       },
  //       {
  //         name: "cat 3",
  //         slug: "cat3"
  //       }
  //     ]
  //   },
  //   {
  //     id: "TWO",
  //     events: [
  //       {
  //         title: "other one",
  //         startTime: "2019-10-01T10:00:00",
  //         endTime: "2019-10-01T12:00:00",
  //         address: "124 Main St",
  //         eventLink: "/",
  //         categories: [
  //           {
  //             slug: "dog1"
  //           },
  //           {
  //             slug: "cat2"
  //           }
  //         ]
  //       },
  //       {
  //         title: "other two",
  //         startTime: "2019-10-02T00:00:00",
  //         endTime: "2019-10-03T00:00:00",
  //         address: "124 Main St",
  //         eventLink: "/",
  //         categories: [
  //           {
  //             slug: "dog2"
  //           },
  //           {
  //             slug: "dog3"
  //           }
  //         ]
  //       },
  //       {
  //         title: "other three",
  //         startTime: "2019-10-05T10:00:00",
  //         endTime: "2019-10-05T12:00:00",
  //         address: "124 Main St",
  //         eventLink: "/",
  //         categories: []
  //       },
  //       {
  //         title: "other four",
  //         startTime: "2019-10-10T10:00:00",
  //         endTime: "2019-11-10T10:00:00",
  //         address: "124 Main St",
  //         eventLink: "/",
  //         categories: [
  //           {
  //             slug: "dog3"
  //           }
  //         ]
  //       }
  //     ],
  //     categories: [
  //       {
  //         name: "dog 1",
  //         slug: "dog1"
  //       },
  //       {
  //         name: "dog 2",
  //         slug: "dog2"
  //       },
  //       {
  //         name: "dog 3",
  //         slug: "dog3"
  //       }
  //     ]
  //   }
  // ]
}

const AppContext = createContext(initialState)

const reducer = (state, action) => {
  switch (action.type) {
    case 'ADD_EVENTS':
      const existing = state.eventLists.find(({ id }) => id === action.id) || {
        events: [],
        categories: [],
        locations: [],
      }
      var newEvents = [...existing.events, ...action.events]
      var newCats = [...existing.categories, ...action.categories]
      var newLocs = [...existing.locations, ...action.locations]
      return {
        ...state,
        eventLists: [
          ...state.eventLists.filter(({ id }) => id !== action.id),
          {
            id: action.id,
            events: newEvents,
            categories: newCats,
            locations: newLocs,
          },
        ],
      }
    default:
      return state
  }
}

const AppProvider = ({ children }) => {
  const [appState, appDispatch] = useReducer(reducer, initialState)

  return (
    <AppContext.Provider value={{ appState, appDispatch }}>
      {children}
    </AppContext.Provider>
  )
}

const AppConsumer = AppContext.Consumer

export { AppContext, AppProvider, AppConsumer }
